<template>
  <!-- 使用 ant-design-vue 图标 -->
  <template v-if="type === 'point'">
    <EnvironmentOutlined :style="iconStyle" />
  </template>
  <template v-else-if="type === 'polyline'">
    <LineOutlined :style="iconStyle" />
  </template>
  <template v-else-if="type === 'polygon'">
    <BorderOuterOutlined :style="iconStyle" />
  </template>
  <template v-else-if="type === 'circle'">
    <CiCircleOutlined :style="iconStyle" />
  </template>
</template>

<script setup lang="ts">
import { computed, withDefaults, defineProps, CSSProperties } from 'vue'

interface Props {
  type: 'point' | 'polyline' | 'polygon' | 'circle';
  color: string;
  size?: number;
}

const props = withDefaults(defineProps<Props>(), {
  size: 16
})

const iconStyle = computed<CSSProperties>(() => ({
  color: props.color,
  fontSize: `${props.size}px`
}))
</script>
